import React, { FC, useState } from 'react';
import { useParams } from 'react-router';

import { EvErrorCard, useSkipLinks } from '@evinced-private/ui-common';

import { MobileSdkComponentDetailsBlock } from 'src/apps/mobile-sdk/components/MobileSdkComponentDetailsBlock';
import { useMobileSdkIssueQuery } from 'src/apps/mobile-sdk/hooks/useMobileSdkIssueQuery';
import { useSetMobileSdkBreadcrumbs } from 'src/apps/mobile-sdk/hooks/useSetMobileSdkBreadcrumbs';
import { useWhiteBackground } from 'src/common/hooks/useWhiteBackground';
import { DASHBOARD_ERROR_MSG } from 'src/common/pages/dashboards-container/errorMessages';

import './MobileSdkSingleIssuePage.scss';

export const MobileSdkSingleIssuePage: FC = () => {
	const { testId, issueId } = useParams<{ testId: string; issueId: string }>();
	const [error, setError] = useState(null);

	useSkipLinks(true);
	useWhiteBackground();
	const issueQuery = useMobileSdkIssueQuery(issueId, testId);
	useSetMobileSdkBreadcrumbs(testId, issueQuery?.data?.testName ?? '');

	return (
		<div className="mobile-sdk-issue-details-page">
			{error ? (
				<EvErrorCard title="Error" contactUsMessage={DASHBOARD_ERROR_MSG} />
			) : (
				<MobileSdkComponentDetailsBlock
					testId={testId}
					issueId={issueId}
					scanName={issueQuery.data?.scanName}
					runTime={issueQuery.data?.runTime}
					issueNumber={issueQuery.data?.shortNodeId}
					isFullPageMode
					setError={setError}
				/>
			)}
		</div>
	);
};
